export enum Routes_Path {
  // for playing with routes, use this tool - http://forbeslindesay.github.io/express-route-tester/
  LANDING_PAGE = '/track',
  RECYCLE_PAGE = '/recycle',
}
